export default {
  title: '推荐管理',
  tab: '推荐',
  menu: {
    referralStatus: '推荐管理',
    companyReferrers: '公司推荐',
    pointsRecord: '积分记录'
  },
  leaderboard: {
    title: '公司推荐榜单',
    filter: {
      allCompanies: '全部公司',
      company: '公司名称',
      referrerType: '推荐人类型',
      startTime: '开始时间',
      endTime: '结束时间',
      tip: '推荐数据每日计算，当日数据会于隔日上午9时后显示。',
      keyword: '关键字搜索'
    },
    referrerType: {
      all: '全部推荐人',
      employee: '员工推荐人',
      nonEmployee: '非员工推荐人'
    },
    column: {
      referrer: '推荐人',
      employeeStatus: '员工状态',
      company: '员工公司',
      employeeId: '员工 ID',
      email: '邮箱',
      views: '已查看',
      submits: '已提交简历',
      applied: '已申请',
      interviewed: '已面试',
      onboard: '已入职',
      probation: '已转正',
      cash: '现金',
      points: '积分',
      all: '全部'
    }
  }
}
